import { BusinessCardApplication } from '../types/business-card.types';

/** Legacy UI: an applicant may edit an application only while it is still pending. */
export const canEditBusinessCard = (application: BusinessCardApplication) =>
  application.Status === 'Pending';

/** `Delivered` is the end of the pipeline: nothing may move an application out of it. */
export const isBusinessCardStatusLocked = (application: BusinessCardApplication) =>
  application.Status === 'Delivered';
